import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'Access'

const myfunction = {
  // GetAccess: function (data) {
  //   return request({
  //     url: setting.getFullUrl(TYPE, 'GetModel'),
  //     method: 'get',
  //     params: data,
  //   })
  // },

  // 合并接口：一次请求获取父账户和子账户的所有权限（Web + APP）
  GetAllAccess: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAllModel'),
      method: 'get',
      params: data,
    })
  },
  //这里是备注

  EditAccess: function (params, data) {
    return request({
      url: setting.getFullUrl(TYPE, 'EditItems'),
      method: 'post',
      params: params,
      data: data,
    })
  },

  EditTrackerAccess: function (params, data) {
    return request({
      url: setting.getFullUrl('User', 'EditTrackerAccess'),
      method: 'post',
      params: params,
      data: data,
    })
  },

  // ========== V2 接口 ==========

  // 获取权限定义（纯配置，不含用户数据）
  GetDefinitions: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetDefinitions'),
      method: 'get',
      params: data,
    })
  },

  // 获取单个账户权限（替代原 GetModel）
  GetOneModelV2: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetOneModelV2'),
      method: 'get',
      params: data,
    })
  },

  // 获取用户权限（定义 + 开关状态，替代原 GetAllModel）
  // 登录跳转依赖此请求：10s 超时后走默认权限兜底，避免弱网下阻塞跳转
  GetModelV2: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetModelV2'),
      method: 'get',
      params: data,
      timeout: 10000,
    })
  },

  // 保存用户权限
  SaveModelV2: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'SaveModelV2'),
      method: 'post',
      data: data,
    })
  },
}

export default myfunction
